<template>
  <div>
    <main>
      <slot></slot>
    </main>
  </div>
</template>

<script>

export default {
  data() {
    return {
      toggleNav: true,
      modalProtocols: false,
      slug: null,
    };
  },
  computed: {
    showButtons() {
      const { name } = this.$route;
      return name === 'Menu';
    },
  },
  created() {
    const { slug } = this.$route.params;
    this.slug = slug;
    const pm = window.sessionStorage.getItem('protocols');
    if (pm) {
      this.modalProtocols = false;
    } else {
      setTimeout(() => {
        this.modalProtocols = true;
      }, 8000);
    }
  },
};
</script>
